export const ABAC_FEATURES = {
  canUseNmRequisite: 'canUseNmRequisite',
  isSupplyAvailable: 'isSupplyAvailable',
  isSupplyAvailableReadOnly: 'isSupplyAvailableReadOnly',
  /** для АБ-тестирования доп инфы в детализации */
  supplyShkStatus: 'supplyShkStatus',
};

export const LOCAL_PERMISSIONS_URL_GET =
  window.SUPPLY_ABAC_URL_LOCAL_PERMISSIONS_GET;

export const ABAC_V2_METHOD = 'abacv2.checkaccess';

export const SUPPLIERS_ABAC_SCOPE = 'suppliers';
